import gql from "graphql-tag";

export const OC_UPDATE_PROPERTY = gql`
  mutation updateProperty(
    $resource: String!
    $key: String!
    $value: String!
    $validFrom: Date
  ) {
    updateProperty(
      resource: $resource
      key: $key
      value: $value
      validFrom: $validFrom
    ) {
      resource
      key
      value
      validFrom
    }
  }
`;
